
<form [formGroup]="_form">

  <!--title-->
  <h2 mat-dialog-title>
    <i class="material-icons m-r-10">cloud_upload</i>
    <span>{{'Modules.FileManager.Applications.FileManager.Upload.Title' | translate}}</span>
  </h2>

  <!--content-->
  <mat-dialog-content>

    <!--uploader box-->
    <div class="pc-uploader">
      <div class="upload-box">
        <div class="upload-box-content">

          <!--drop container-->
          <div [hidden]="uploading" class="drop-container" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" [ngClass]="{ 'is-drop-over': dragOver }">
            <div class="inner">
              <i class="material-icons m-r-10">cloud_upload</i>
              <span>{{'Shared.Upload.DragText' | translate}}</span>
              <input type="file" #uploader ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" multiple />
            </div>
          </div>

          <!--files list-->
          @if (_form.get('items')['controls'].length > 0) {
            <ul class="upload-file-list" [hidden]="uploading">
              @for (item of _form.get('items')['controls']; track item; let i = $index) {
                <li formArrayName="items">
                  <div [formGroupName]="i">
                    <div class="row">
                      <div class="col-lg-6">
                        <mat-form-field>
                          <input matInput formControlName="fileName" placeholder="Nome documento" />
                          @if (item.get('fileName').errors?.required && item.get('fileName').touched) {
                            <mat-error>
                              {{'Commons.Validation.Required' | translate : { field: "Nome documento" } }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-lg-6">
                        <mat-form-field>
                          <mat-select formControlName="fileTypeId" placeholder="Tipologia">
                            @for (_fileType of _filetypes; track _fileType) {
                              <mat-option [value]="_fileType.id">{{_fileType.name}}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </li>
              }
            </ul>
          }

          <!--upload box-->
          <div [hidden]="!uploading" class="upload-item--box">
            @for (f of files; track f; let i = $index) {
              <div class="upload-item">
                <div class="upload-item-content">
                  <div class="filename">
                    <div class="filename-left">
                      <i class="ionicon ion-ios-copy"></i>
                      <span>{{ f.name }}</span>
                    </div>
                    <div class="filename-right">
                      <i class="ionicon ion-close-round" (click)="cancelUpload(f.id)"></i>
                    </div>
                  </div>
                  <div class="progress-content">
                    <div class="progress">
                      <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'" [class.is-done]="f?.progress?.data?.percentage === 100"></span>
                    </div>
                  </div>
                  <div class="progress-text-content">
                    <span class="progress-text" [class.is-done]="f?.progress?.data?.percentage === 100">
                      <span>{{ f.progress?.data?.percentage }}% </span>
                      @if (f.progress?.data?.percentage !== 100) {
                        <span>{{'Shared.Upload.Uploading' | translate}}</span>
                      }
                      @if (f.progress?.data?.percentage === 100) {
                        <span>{{'Shared.Upload.Done' | translate}}</span>
                      }
                    </span>
                    @if (f.progress?.data?.percentage !== 0 && f.progress?.data?.percentage !== 100) {
                      <span class="speed-and-eta-text">
                        <span>{{ f.progress?.data?.speedHuman }} </span>
                        <span>ETA {{ f.progress?.data?.etaHuman }}</span>
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>

        </div>
      </div>
    </div>
  </mat-dialog-content>

  <!--actions-->
  @if (_form.get('items')['controls'].length > 0) {
    <mat-dialog-actions>
      <button mat-flat-button mat-ripple color="accent" (click)="startUpload()" [class.disabled]="!_form.valid">
        <i class="material-icons m-r-10">check</i>
        {{'Modules.FileManager.Applications.FileManager.Upload.Confirm' | translate}}
      </button>
      <button mat-button mat-ripple mat-dialog-close>
        {{ 'Commons.Actions.Cancel' | translate }}
      </button>
    </mat-dialog-actions>
  }

</form>
